import apiClient from "@/api/client";
import type { WeeklyPlan, WeeklyPlanFormData } from "@/features/tasks/types";

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

export const weeklyPlansApi = {
  list: (params?: { project?: string }) =>
    apiClient.get<{ data: WeeklyPlan[] }>("/weekly-plans/", { params }).then(wrap),

  get: (id: string) =>
    apiClient.get<{ data: WeeklyPlan }>(`/weekly-plans/${id}/`).then(wrap),

  currentWeek: () =>
    apiClient.get<{ data: WeeklyPlan[] }>("/weekly-plans/current/").then(wrap),

  create: (data: WeeklyPlanFormData) =>
    apiClient.post<{ data: WeeklyPlan }>("/weekly-plans/", data).then(wrap),

  update: (id: string, data: Partial<WeeklyPlanFormData>) =>
    apiClient.patch<{ data: WeeklyPlan }>(`/weekly-plans/${id}/`, data).then(wrap),

  delete: (id: string) => apiClient.delete(`/weekly-plans/${id}/`),

  carryOver: () =>
    apiClient.get<{ data: import("@/features/tasks/types").Task[] }>("/weekly-plans/carry-over/").then(wrap),
};
